import React from 'react';
import LoginForm from '../components/auth/LoginForm';

function LoginPage() {
  return <LoginForm redirectTo="/admin/insights" />;
}

export default LoginPage;
